import classNames from 'classnames';

import { PagePaths } from '@revelio/core';
import { Text } from '@revelio/ui';

import { DeliverableStepContainer } from '../deliverable-step-container';
import { DeliverablePaths } from '../deliverables-page';
import type { DataInterface } from '../file-upload/file-upload.types';
import styles from './completed-step.module.css';
import {
  DEFAULT_TAXONOMY_ID,
  useDataEnrichmentActions,
} from './data-enrichment.store';
import CompletedStatusIcon from './icons/CompletedStatusIcon';
import type { SelectedOptionsInterface } from './types/dataEnrichmentTypes';

const CompletedStep = ({
  setData,
  setActiveStep,
  setSelectedOptions,
}: {
  setData: React.Dispatch<React.SetStateAction<DataInterface>>;
  setActiveStep: (step: number) => void;
  setSelectedOptions: React.Dispatch<
    React.SetStateAction<SelectedOptionsInterface[]>
  >;
}) => {
  const { setEnrichmentJobTaxonomySettings, setEnrichmentModals } =
    useDataEnrichmentActions();
  const reset = () => {
    setData({
      workbook: { Sheets: {}, SheetNames: [] },
      sheetNames: [],
      mappedWorkbook: [[]],
      selectedSheet: '',
      headers: [],
      headerIndex: '',
      combinedData: [{}],
      fileType: 'csv',
      mappedColumns: [],
      oryId: '',
      clientName: '',
      email: '',
      s3FileLocation: '',
    });
    setActiveStep(0);
    setSelectedOptions([]);
    setEnrichmentModals([]);
    setEnrichmentJobTaxonomySettings({
      taxonomyId: DEFAULT_TAXONOMY_ID,
      includeV2: false,
    });
  };
  return (
    <DeliverableStepContainer
      id="completed"
      title="Completed"
      startOverPath={`/${PagePaths.DELIVERABLES}/${DeliverablePaths.DATASET}`}
      submitButtonContent="Upload Another"
      onSubmit={reset}
      disableFade
      isDataBuilder={false}
    >
      <div className={classNames(styles.completedBody, styles.statusMessage)}>
        <CompletedStatusIcon />
        <Text className={styles.statusText}>
          Enrichment in progress. <br />
          You'll receive an email shortly with a download link to your enriched
          dataset.
        </Text>
      </div>
    </DeliverableStepContainer>
  );
};

export default CompletedStep;
